import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Constants } from '@sharedConstants/constants';

import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AppContextService } from '@core/services/app-context.service';

@Injectable({
  providedIn: 'root',
})
export class ResourceService {
  private translateFiles: any = [];
  private currentLang: string;
  public translateFile$: BehaviorSubject<any>;

  constructor(
    private http: HttpClient,
    private appContextService: AppContextService
  ) {
  }

  initService = (): Promise<any> => {
    this.currentLang = this.appContextService.lang;

    this.translateFile$ = new BehaviorSubject<any>(
      this.translateFiles[this.currentLang]
    );

    return this.initResource();
  }

  getResourceFromWebApi = (): any => {
    return this.http.post(
      this.appContextService.publicApiUrl + '/LoadResource',
      JSON.stringify(this.currentLang),
      Constants.httpOptions
    );
  }

  initResource = (): Promise<any> => {
    return this.getResourceFromWebApi()
      .pipe(
        tap((response: any) => {
          this.translateFiles[this.currentLang] = JSON.parse(response.data);
          this.translateFile$.next(this.translateFiles[this.currentLang]);

          this.appContextService.getLang().subscribe((lang) => {
            this.loadResource(lang);
          });
        })
      )
      .toPromise();
  }

  loadResource = (lang: string): void => {
    this.currentLang = lang;

    if (this.translateFiles[this.currentLang] === undefined) {
      this.getResourceFromWebApi().subscribe((response: any) => {
        this.translateFiles[this.currentLang] = JSON.parse(response.data);
        this.translateFile$.next(this.translateFiles[this.currentLang]);
      });
    } else {
      this.translateFile$.next(this.translateFiles[this.currentLang]);
    }
  }

  getResource = () => {
    return this.translateFiles[this.currentLang];
  }
}
